import {fromEvent, Observable} from 'rxjs';
import {map}                   from 'rxjs/operators';

import IErrorsPayload from '../../../Player/Interfaces/IErrorsPayload';
import ErrorType      from '../../../Shared/Constants/ErrorType';
import Html5          from '../Html5';

const mapToMediaError = (source: Event): IErrorsPayload => ({
    type: ErrorType.UNKNOWN_SOLUTION_ERROR,
    source
});

const createMediaErrorsStream = (solution: Html5): Observable<IErrorsPayload> =>
    fromEvent(solution.videoElement, 'error')
        .pipe(
            map(mapToMediaError)
        );

export default createMediaErrorsStream;